import { FC, PropsWithChildren, useState } from "react";
import { FormSectionHeader } from "./FormSectionHeader";
import { FormSectionTextField } from "./FormSectionTextField";
import { FormSectionToggle } from "./FormSectionToggle";
import { FormSectionProps, FormSectionSubComponents } from "./FormSection.props";
import { Section } from "../Section";
import Grid from "../Grid";
import { Form } from "../Form";

/**
 * @deprecated
 */
export const FormSection: FC<PropsWithChildren<FormSectionProps>> & FormSectionSubComponents = ({
  id,
  children,
  handleSubmit,
  title,
  defaultValues,
}: PropsWithChildren<FormSectionProps>): JSX.Element => {
  const [readOnly, setReadOnly] = useState(true);

  const onSubmit = (formValues: unknown) => {
    handleSubmit(formValues);
    setReadOnly(true);
  };

  return (
    <Form id={id} testId={id} onSubmit={onSubmit} readOnlyForm={readOnly} defaultValues={defaultValues}>
      <Section
        header={<FormSectionHeader title={title} readOnly={readOnly} setReadOnly={setReadOnly} />}
        id="form-section"
        testId="form-section"
      >
        <Grid container id="form-section-grid-container">
          {children}
        </Grid>
      </Section>
    </Form>
  );
};

FormSection.TextField = FormSectionTextField;
FormSection.Toggle = FormSectionToggle;
